module.exports = __webpack_public_path__ + "LatoLatin-HairlineItalic.41da733bdf40d2263438.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-HairlineItalic.woff2
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-HairlineItalic.woff2
// module chunks = styles